<template>
  <div class="product-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入藏品名称/藏家手机号/支付订单号查找..."
                 style="width:300px"></Input>
        </FormItem>
        <FormItem>
          <DatePicker type="daterange"
                      format="yyyy-MM-dd"
                      split-panels
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 详情弹层 start-->
    <Drawer width="50"
            v-model="showModalStatus"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="showModalStatus = false">
      <Form label-position="left"
            :label-width="100">
        <Row>
          <Col :xs="24"
               :md="24">
          <FormItem label="支付订单编号">
            <span>{{ goods.pay_order_num }}</span>
          </FormItem>
          <FormItem label="支付时间">
            <span>{{ goods.pay_at }}</span>
          </FormItem>
          <FormItem label="支付金额">
            <span>{{ goods.total_price }}</span>
          </FormItem>
          <FormItem label="余额支付">
            <span>{{ goods.user_money }}</span>
          </FormItem>
          <FormItem label="微信支付">
            <span>{{ goods.wx_money }}</span>
          </FormItem>
          <FormItem label="充值卡支付">
            <span>{{ goods.charge_card }}</span>
          </FormItem>
          </Col>
        </Row>
      </Form>
    </Drawer>
    <!-- 详情弹层 end -->
  </div>
</template>

<script>
export default {
  name: 'product-list',
  data () {
    return {
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      goods: {
        item_name: '',
        catename: '',
        type: "",
        describe: '',
        thumb: '',
        model_file: '',
      },
      editor: {
        ifno: '',
      },
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
      },
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '标题',
          key: 'name',
          minWidth: 300,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '订单编号:' + params.row.pay_order_num),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '哈希值:' + params.row.order_blockchain_id)
            ]);
          }
        },
        {
          title: '藏家',
          key: 'username',
          minWidth: 300,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '名称:' + params.row.collector.user.username),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '哈希值:' + params.row.collector.collector_blockchain_id)
            ]);
          }
        },
        {
          title: '藏品',
          key: 'name',
          minWidth: 300,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '名称:' + params.row.orderphoto.name),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '哈希值:' + params.row.orderphoto.blockchain_id)
            ]);
          }
        },
        {
          title: '金额',
          key: 'total_price',
          minWidth: 100,
        },
        {
          title: '支付方式',
          key: 'pay_name',
          minWidth: 100,
        },
        {
          title: '支付状态',
          key: 'pay_status',
          minWidth: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {
              }, params.row.pay_status == 0 ? "未支付" : params.row.pay_status == 1 ? "支付中" : "支付完成")
            ]);
          }
        },
        {
          title: '订单状态',
          key: 'order_status',
          minWidth: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {
              }, params.row.order_status == 1 ? "正常" : "关闭")
            ]);
          }
        },
        {
          title: '下单时间',
          key: 'created_at',
          minWidth: 180,
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.row.id)
                  }
                }
              }, '详情')
            ]);

          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      id: 0,
      datetime: [],
    }
  },
  created: function () {
    this.getTableList();

  },
  components: {
  },

  methods: {
    getTableList: function () {
      this.$api.collectionorder.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 详情
    detail (id) {
      this.title = "编辑商品";
      this.showModalStatus = !this.showModalStatus;
      this.$api.collectionorder.detail({ id: id }).then(res => {
        this.goods = res.result;
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    changeDate (val) {
      this.datetime = val;
    },
    // 筛选
    renderTable: function (name) {
      var starttime = this.datetime[0] != undefined ? this.datetime[0] : "";
      var endtime = this.datetime[1] != undefined ? this.datetime[1] : "";
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        starttime: starttime,
        endtime: endtime,
      };
      this.$api.collectionorder.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },

  },
}
</script>

